require('./blocks/benefits/benefits');
require('./blocks/benefit.less');
require('./blocks/fullwidth-slider/fullwidth-slider');
require('./blocks/showcase.less');
require('./blocks/topseller.less');
require('./blocks/product/product');
require('./blocks/products-slider/products-slider');
require('./blocks/section-slider/section-slider');
require('./blocks/brands-slider/brands-slider.less');
require('./blocks/brands-slider/slider-resize-controll');
require('./blocks/calendar-item.less');
require('./blocks/tiles/tiles');
require('./blocks/seminar.less');
require('./blocks/news-list/news-list');
require('./blocks/main-block.less');
require('./blocks/news-item/news-item');
require('./blocks/reviews/reviews');
require('./blocks/review.less');
require('./blocks/subscribe-form/subscribe-form');
require('./blocks/seo-text.less');
require('./blocks/soc-marks.less');
require('./blocks/promos/promos.less');
require('./blocks/promos/promos');



// WEBPACK FOOTER //
// ./index.js